module.exports = __webpack_public_path__ + "static/assets/38388cdbfe7abdff863355fe1e74853e.png";